import Api from '@/utils/Api';

export const createClientBill = async (clientId, data) => {
  return await Api.post(`clients/${clientId}/bills`, data);
};
